export default __webpack_public_path__ + "static/media/audio-on.4bf14dbb.svg";